import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-log-out-icon',
  imports: [],
  templateUrl: './log-out-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './log-out-icon.component.scss',
})
export class LogOutIconComponent {}
